export default __webpack_public_path__ + "static/rendered-design-e00309ed95ec6b886d639defa806f939.png";